// Contrato de datos devuelto por premios.get_public_stats() (solo agregados).
export interface WrappedStats {
  edition: number;
  totals: { received: number; approved: number; pending: number; rejected: number };
  countries: { name: string; count: number }[];
  regions: { name: string; count: number }[];
  gov_levels: { name: string; count: number; pct: number }[];
  categories: { name: string; type: 'project' | 'personal' | 'benchmark'; count: number }[];
  institutions: { count: number; names: string[] };
  with_social: number;
}

// Coordenadas aproximadas (lon, lat) de los países participantes, para el mapa.
export const COUNTRY_GEO: Record<string, { lon: number; lat: number; short: string }> = {
  'España': { lon: -3.7, lat: 40.4, short: 'ES' },
  'México': { lon: -102, lat: 23.6, short: 'MX' },
  'Argentina': { lon: -64, lat: -34.6, short: 'AR' },
  'Colombia': { lon: -74, lat: 4.6, short: 'CO' },
  'Chile': { lon: -71, lat: -35.7, short: 'CL' },
  'República Dominicana': { lon: -70.7, lat: 19, short: 'DO' },
  'Uruguay': { lon: -56, lat: -33, short: 'UY' },
  'Perú': { lon: -75, lat: -9.2, short: 'PE' },
};
